module.exports = __webpack_public_path__ + "static/media/fa-solid-900.08b3d092.ttf";